// source: mlmbox/type/staking.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_bonus_pb = require('../../mlmbox/type/bonus_pb.js');
goog.object.extend(proto, mlmbox_type_bonus_pb);
var mlmbox_type_payment_pb = require('../../mlmbox/type/payment_pb.js');
goog.object.extend(proto, mlmbox_type_payment_pb);
goog.exportSymbol('proto.mlmbox.type.Staking', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Account', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Account.Asset', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Account.Asset.State', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Contract', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Contract.ID', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Package', null, global);
goog.exportSymbol('proto.mlmbox.type.Staking.Package.ID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Staking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.displayName = 'proto.mlmbox.type.Staking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Package = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Staking.Package, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Package.displayName = 'proto.mlmbox.type.Staking.Package';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Package.ID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Staking.Package.ID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Package.ID.displayName = 'proto.mlmbox.type.Staking.Package.ID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Contract = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Staking.Contract, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Contract.displayName = 'proto.mlmbox.type.Staking.Contract';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Contract.ID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Staking.Contract.ID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Contract.ID.displayName = 'proto.mlmbox.type.Staking.Contract.ID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.type.Staking.Account.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.type.Staking.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Account.displayName = 'proto.mlmbox.type.Staking.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Account.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.type.Staking.Account.Asset.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.type.Staking.Account.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Account.Asset.displayName = 'proto.mlmbox.type.Staking.Account.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Staking.Account.Asset.State = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.type.Staking.Account.Asset.State.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.type.Staking.Account.Asset.State, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Staking.Account.Asset.State.displayName = 'proto.mlmbox.type.Staking.Account.Asset.State';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking}
 */
proto.mlmbox.type.Staking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking;
  return proto.mlmbox.type.Staking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking}
 */
proto.mlmbox.type.Staking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Package.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Package.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Package} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Package.toObject = function(includeInstance, msg) {
  var f, obj = {
    packageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    packageTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contractAssetId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    lockupDurationMonthValue: jspb.Message.getFieldWithDefault(msg, 4, 0),
    paymentPriceRange: (f = msg.getPaymentPriceRange()) && mlmbox_type_payment_pb.PaymentPriceRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Package}
 */
proto.mlmbox.type.Staking.Package.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Package;
  return proto.mlmbox.type.Staking.Package.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Package} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Package}
 */
proto.mlmbox.type.Staking.Package.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPackageId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractAssetId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLockupDurationMonthValue(value);
      break;
    case 5:
      var value = new mlmbox_type_payment_pb.PaymentPriceRange;
      reader.readMessage(value,mlmbox_type_payment_pb.PaymentPriceRange.deserializeBinaryFromReader);
      msg.setPaymentPriceRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Package.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Package.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Package} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Package.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPackageTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContractAssetId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getLockupDurationMonthValue();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPaymentPriceRange();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      mlmbox_type_payment_pb.PaymentPriceRange.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Package.ID.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Package.ID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Package.ID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Package.ID.toObject = function(includeInstance, msg) {
  var f, obj = {
    packageId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Package.ID}
 */
proto.mlmbox.type.Staking.Package.ID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Package.ID;
  return proto.mlmbox.type.Staking.Package.ID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Package.ID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Package.ID}
 */
proto.mlmbox.type.Staking.Package.ID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPackageId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Package.ID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Package.ID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Package.ID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Package.ID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 package_id = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Package.ID.prototype.getPackageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Package.ID} returns this
 */
proto.mlmbox.type.Staking.Package.ID.prototype.setPackageId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 package_id = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Package.prototype.getPackageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Package} returns this
 */
proto.mlmbox.type.Staking.Package.prototype.setPackageId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string package_title = 2;
 * @return {string}
 */
proto.mlmbox.type.Staking.Package.prototype.getPackageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Package} returns this
 */
proto.mlmbox.type.Staking.Package.prototype.setPackageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 contract_asset_id = 3;
 * @return {number}
 */
proto.mlmbox.type.Staking.Package.prototype.getContractAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Package} returns this
 */
proto.mlmbox.type.Staking.Package.prototype.setContractAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 lockup_duration_month_value = 4;
 * @return {number}
 */
proto.mlmbox.type.Staking.Package.prototype.getLockupDurationMonthValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Package} returns this
 */
proto.mlmbox.type.Staking.Package.prototype.setLockupDurationMonthValue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional PaymentPriceRange payment_price_range = 5;
 * @return {?proto.mlmbox.type.PaymentPriceRange}
 */
proto.mlmbox.type.Staking.Package.prototype.getPaymentPriceRange = function() {
  return /** @type{?proto.mlmbox.type.PaymentPriceRange} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_payment_pb.PaymentPriceRange, 5));
};


/**
 * @param {?proto.mlmbox.type.PaymentPriceRange|undefined} value
 * @return {!proto.mlmbox.type.Staking.Package} returns this
*/
proto.mlmbox.type.Staking.Package.prototype.setPaymentPriceRange = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.Staking.Package} returns this
 */
proto.mlmbox.type.Staking.Package.prototype.clearPaymentPriceRange = function() {
  return this.setPaymentPriceRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.Staking.Package.prototype.hasPaymentPriceRange = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Contract.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Contract.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Contract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Contract.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    packageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    assetId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    packageTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lockupDurationMonthReady: jspb.Message.getFieldWithDefault(msg, 5, 0),
    lockupDurationMonthTarget: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lockupInitBodyValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    lockupValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    turnoverUsdtValue: jspb.Message.getFieldWithDefault(msg, 9, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
    closed: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    closedAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
    nextAt: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Contract}
 */
proto.mlmbox.type.Staking.Contract.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Contract;
  return proto.mlmbox.type.Staking.Contract.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Contract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Contract}
 */
proto.mlmbox.type.Staking.Contract.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAssetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageTitle(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLockupDurationMonthReady(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLockupDurationMonthTarget(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockupInitBodyValue(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockupValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnoverUsdtValue(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreatedAt(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClosed(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClosedAt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNextAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Contract.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Contract.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Contract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Contract.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPackageId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getAssetId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPackageTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLockupDurationMonthReady();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getLockupDurationMonthTarget();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getLockupInitBodyValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLockupValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTurnoverUsdtValue();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getClosed();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getClosedAt();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getNextAt();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Contract.ID.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Contract.ID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Contract.ID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Contract.ID.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Contract.ID}
 */
proto.mlmbox.type.Staking.Contract.ID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Contract.ID;
  return proto.mlmbox.type.Staking.Contract.ID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Contract.ID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Contract.ID}
 */
proto.mlmbox.type.Staking.Contract.ID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Contract.ID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Contract.ID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Contract.ID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Contract.ID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 contract_id = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.ID.prototype.getContractId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract.ID} returns this
 */
proto.mlmbox.type.Staking.Contract.ID.prototype.setContractId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 contract_id = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getContractId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setContractId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 package_id = 2;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getPackageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setPackageId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 asset_id = 3;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string package_title = 4;
 * @return {string}
 */
proto.mlmbox.type.Staking.Contract.prototype.getPackageTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setPackageTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 lockup_duration_month_ready = 5;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getLockupDurationMonthReady = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setLockupDurationMonthReady = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 lockup_duration_month_target = 6;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getLockupDurationMonthTarget = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setLockupDurationMonthTarget = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string lockup_init_body_value = 7;
 * @return {string}
 */
proto.mlmbox.type.Staking.Contract.prototype.getLockupInitBodyValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setLockupInitBodyValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string lockup_value = 8;
 * @return {string}
 */
proto.mlmbox.type.Staking.Contract.prototype.getLockupValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setLockupValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string turnover_usdt_value = 9;
 * @return {string}
 */
proto.mlmbox.type.Staking.Contract.prototype.getTurnoverUsdtValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setTurnoverUsdtValue = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint32 created_at = 10;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool closed = 11;
 * @return {boolean}
 */
proto.mlmbox.type.Staking.Contract.prototype.getClosed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setClosed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional uint32 closed_at = 12;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getClosedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setClosedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 next_at = 13;
 * @return {number}
 */
proto.mlmbox.type.Staking.Contract.prototype.getNextAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Contract} returns this
 */
proto.mlmbox.type.Staking.Contract.prototype.setNextAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.type.Staking.Account.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetsList: jspb.Message.toObjectList(msg.getAssetsList(),
    proto.mlmbox.type.Staking.Account.Asset.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Account}
 */
proto.mlmbox.type.Staking.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Account;
  return proto.mlmbox.type.Staking.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Account}
 */
proto.mlmbox.type.Staking.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mlmbox.type.Staking.Account.Asset;
      reader.readMessage(value,proto.mlmbox.type.Staking.Account.Asset.deserializeBinaryFromReader);
      msg.addAssets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mlmbox.type.Staking.Account.Asset.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.type.Staking.Account.Asset.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Account.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Account.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: (f = msg.getState()) && proto.mlmbox.type.Staking.Account.Asset.State.toObject(includeInstance, f),
    contractsList: jspb.Message.toObjectList(msg.getContractsList(),
    proto.mlmbox.type.Staking.Contract.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Account.Asset}
 */
proto.mlmbox.type.Staking.Account.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Account.Asset;
  return proto.mlmbox.type.Staking.Account.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Account.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Account.Asset}
 */
proto.mlmbox.type.Staking.Account.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAssetId(value);
      break;
    case 2:
      var value = new proto.mlmbox.type.Staking.Account.Asset.State;
      reader.readMessage(value,proto.mlmbox.type.Staking.Account.Asset.State.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 3:
      var value = new proto.mlmbox.type.Staking.Contract;
      reader.readMessage(value,proto.mlmbox.type.Staking.Contract.deserializeBinaryFromReader);
      msg.addContracts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Account.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Account.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.mlmbox.type.Staking.Account.Asset.State.serializeBinaryToWriter
    );
  }
  f = message.getContractsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.mlmbox.type.Staking.Contract.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.type.Staking.Account.Asset.State.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Staking.Account.Asset.State.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Staking.Account.Asset.State} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.Asset.State.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractsQuantityTotal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contractsQuantityActivated: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lockupInitBodyTotalValue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lockupTotalValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    turnoverUsdtLimit: jspb.Message.getFieldWithDefault(msg, 5, ""),
    turnoverUsdtValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    bonusesList: jspb.Message.toObjectList(msg.getBonusesList(),
    mlmbox_type_bonus_pb.Bonus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State}
 */
proto.mlmbox.type.Staking.Account.Asset.State.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Staking.Account.Asset.State;
  return proto.mlmbox.type.Staking.Account.Asset.State.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Staking.Account.Asset.State} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State}
 */
proto.mlmbox.type.Staking.Account.Asset.State.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractsQuantityTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setContractsQuantityActivated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockupInitBodyTotalValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockupTotalValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnoverUsdtLimit(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnoverUsdtValue(value);
      break;
    case 7:
      var value = new mlmbox_type_bonus_pb.Bonus;
      reader.readMessage(value,mlmbox_type_bonus_pb.Bonus.deserializeBinaryFromReader);
      msg.addBonuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Staking.Account.Asset.State.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Staking.Account.Asset.State} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Staking.Account.Asset.State.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractsQuantityTotal();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getContractsQuantityActivated();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getLockupInitBodyTotalValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockupTotalValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTurnoverUsdtLimit();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTurnoverUsdtValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBonusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      mlmbox_type_bonus_pb.Bonus.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 contracts_quantity_total = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getContractsQuantityTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setContractsQuantityTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 contracts_quantity_activated = 2;
 * @return {number}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getContractsQuantityActivated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setContractsQuantityActivated = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string lockup_init_body_total_value = 3;
 * @return {string}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getLockupInitBodyTotalValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setLockupInitBodyTotalValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string lockup_total_value = 4;
 * @return {string}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getLockupTotalValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setLockupTotalValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string turnover_usdt_limit = 5;
 * @return {string}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getTurnoverUsdtLimit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setTurnoverUsdtLimit = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string turnover_usdt_value = 6;
 * @return {string}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getTurnoverUsdtValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setTurnoverUsdtValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Bonus bonuses = 7;
 * @return {!Array<!proto.mlmbox.type.Bonus>}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.getBonusesList = function() {
  return /** @type{!Array<!proto.mlmbox.type.Bonus>} */ (
    jspb.Message.getRepeatedWrapperField(this, mlmbox_type_bonus_pb.Bonus, 7));
};


/**
 * @param {!Array<!proto.mlmbox.type.Bonus>} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
*/
proto.mlmbox.type.Staking.Account.Asset.State.prototype.setBonusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.mlmbox.type.Bonus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.type.Bonus}
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.addBonuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.mlmbox.type.Bonus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.type.Staking.Account.Asset.State} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.State.prototype.clearBonusesList = function() {
  return this.setBonusesList([]);
};


/**
 * optional uint32 asset_id = 1;
 * @return {number}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.getAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.setAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional State state = 2;
 * @return {?proto.mlmbox.type.Staking.Account.Asset.State}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.getState = function() {
  return /** @type{?proto.mlmbox.type.Staking.Account.Asset.State} */ (
    jspb.Message.getWrapperField(this, proto.mlmbox.type.Staking.Account.Asset.State, 2));
};


/**
 * @param {?proto.mlmbox.type.Staking.Account.Asset.State|undefined} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset} returns this
*/
proto.mlmbox.type.Staking.Account.Asset.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.Staking.Account.Asset} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.hasState = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Contract contracts = 3;
 * @return {!Array<!proto.mlmbox.type.Staking.Contract>}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.getContractsList = function() {
  return /** @type{!Array<!proto.mlmbox.type.Staking.Contract>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mlmbox.type.Staking.Contract, 3));
};


/**
 * @param {!Array<!proto.mlmbox.type.Staking.Contract>} value
 * @return {!proto.mlmbox.type.Staking.Account.Asset} returns this
*/
proto.mlmbox.type.Staking.Account.Asset.prototype.setContractsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.mlmbox.type.Staking.Contract=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.type.Staking.Contract}
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.addContracts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mlmbox.type.Staking.Contract, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.type.Staking.Account.Asset} returns this
 */
proto.mlmbox.type.Staking.Account.Asset.prototype.clearContractsList = function() {
  return this.setContractsList([]);
};


/**
 * repeated Asset assets = 1;
 * @return {!Array<!proto.mlmbox.type.Staking.Account.Asset>}
 */
proto.mlmbox.type.Staking.Account.prototype.getAssetsList = function() {
  return /** @type{!Array<!proto.mlmbox.type.Staking.Account.Asset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mlmbox.type.Staking.Account.Asset, 1));
};


/**
 * @param {!Array<!proto.mlmbox.type.Staking.Account.Asset>} value
 * @return {!proto.mlmbox.type.Staking.Account} returns this
*/
proto.mlmbox.type.Staking.Account.prototype.setAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mlmbox.type.Staking.Account.Asset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.type.Staking.Account.Asset}
 */
proto.mlmbox.type.Staking.Account.prototype.addAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mlmbox.type.Staking.Account.Asset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.type.Staking.Account} returns this
 */
proto.mlmbox.type.Staking.Account.prototype.clearAssetsList = function() {
  return this.setAssetsList([]);
};


goog.object.extend(exports, proto.mlmbox.type);
